import { render, staticRenderFns } from "./SecondaryButton.vue?vue&type=template&id=79e8c688&"
import script from "./SecondaryButton.vue?vue&type=script&lang=ts&"
export * from "./SecondaryButton.vue?vue&type=script&lang=ts&"
import style0 from "./SecondaryButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports